import { WithTooltip } from 'basic-components';

export const PickersUtils =  (() => {
  const getErrorTooltip = (errorMessage, className) => (
    <WithTooltip
        color="red-light"
        data-place="right"
        text={errorMessage}
        >
      <div className={className}>More</div>
    </WithTooltip>
  )

  return {
    getErrorTooltip
  }
})();